<template>
  <div>
    <div
      class="
        pl-4
        pr-4
        sm:pl-12
        md:pl-20
        lg:pl-48
        bottom-0
        pb-48
        max-w-4xl
        absolute
        z-10
      "
    >
      <img
        v-if="decoration"
        class="pl-2 pb-6 w-32"
        :src="getImgUrl(decoration)"
        alt=""
      />
      <h2
        v-if="headline"
        class="
          text-4xl text-white
          sm:text-6xl
          font-normal
          pb-6
          font-serif
          leading-none
        "
      >
        {{ headline }}
      </h2>
      <p
        v-if="intro"
        class="sm:text-lg hidden sm:block text-white sm:leading-relaxed pb-8"
      >
        {{ intro }}
      </p>
      <router-link
        v-if="btnText && btnTarget"
        :to="btnTarget"
        class="
          text-white
          uppercase
          font-semibold
          text-sm
          tracking-wider
          opacity-75
          pb-1
          py-4
          border-b
          z-50
        "
        >{{ btnText }}
      </router-link>
      <!-- <a
        v-if="btnText && btnTarget"
        class="text-white uppercase font-semibold text-sm tracking-wider opacity-75 pb-1 border-b"
        :href="btnTarget"
      >
        {{ btnText }}
      </a> -->
    </div>
    <img
      class="
        w-screen
        h-screen
        object-cover object-center
        bg-gray-300
        opacity-75
      "
      :src="getImgUrl(this.src)"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: 'PageSlideItem',
  props: {
    headline: String,
    intro: String,
    src: String,
    decoration: String,
    btnText: String,
    btnTarget: String,
  },
  methods: {
    getImgUrl(img) {
      return require('../assets/' + img)
    },
  },
}
</script>
<style scoped>
router-link:hover {
  @apply pb-2 opacity-100 transition-all ease-in-out duration-150;
}
</style>
